import { mergeMap, map, filter, take, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { isAuthenticatedSelector } from '@cbridge-packages/auth';
import { queryParamSelector } from '@cbridge-packages/routing';
import { PageContextAction } from '@cbridge-packages/page-context';
import { ServersFilterAction } from '../serversFilter.action';
import { ServerParam } from '../_helpers/serverSearchParam';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>
  & IGetSelectorStateType<typeof isAuthenticatedSelector>;

export const initServersFilterEpic: IEpic<IState> = (action$, state$) => {
  return state$.pipe(
    map((state) => ({
      serverId: queryParamSelector(state, ServerParam.name),
      isAuthenticated: isAuthenticatedSelector(state),
    })),
    filter(({ serverId, isAuthenticated }) => serverId && isAuthenticated),
    distinctUntilChanged(),
    take(1),
    mergeMap(({ serverId }) => {
      return [
        ServersFilterAction.select({ serverId }),
      ];
    }),
    takeUntil(
      action$.pipe(
        isTypeOf(PageContextAction.init.done, PageContextAction.init.failed),
      ),
    ),
  );
};
